export abstract class OdooRecord {
    id: number
    name: string
}
